/**
 * Utility functions for extracting and processing AI responses
 */

import { replaceDosageWithDose } from '../textUtils';

/**
 * Extracts AI response from WebSocket message data
 * Handles both response and reprompt_message fields
 */
export const extractAIResponse = (messageData: any): string => {
  const apiResponse = replaceDosageWithDose(messageData?.response || "");
  const repromptMessage = replaceDosageWithDose(messageData?.validation?.reprompt_message || "");
  return apiResponse || repromptMessage || "";
};

